import type React from 'react';
import { useCallback } from 'react';

type KeyHandlers = {
  Submit?: (event: React.KeyboardEvent, ...rest: any[]) => void;
  ArrowUp?: (event: React.KeyboardEvent, ...rest: any[]) => void;
  ArrowRight?: (event: React.KeyboardEvent, ...rest: any[]) => void;
  ArrowDown?: (event: React.KeyboardEvent, ...rest: any[]) => void;
  ArrowLeft?: (event: React.KeyboardEvent, ...rest: any[]) => void;
  Escape?: (event: React.KeyboardEvent, ...rest: any[]) => void;
};

const useKeyboard = (keyHandlers: KeyHandlers) => {
  const keyboardHandler = useCallback(
    (event: React.KeyboardEvent, ...rest) => {
      for (const [keyboardKey, keyboardHandler] of Object.entries(keyHandlers)) {
        const key = keyboardKey === 'Submit' ? ['Enter', ' '] : [keyboardKey];
        if (key.some((k) => k === event.key)) {
          event.preventDefault();
          keyboardHandler?.(event, ...rest);
        }
      }
    },
    [keyHandlers],
  );
  return keyboardHandler;
};

export default useKeyboard;
